import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import { CreateElement, VNode } from "vue";
import "../index.less";
import { getImg, getTxt } from "@/utils";
import { cloneDeep } from "lodash";
import { RepairFileVo } from "@/service-proxies/app-v2/tpm.service-proxies";
import previewImg from "@/components/PreviewImg/index.vue";
import { ServiceProxy as ResourceServiceProxy } from "@/service-proxies/app-v2/resource.service-proxies";
const resourceService = new ResourceServiceProxy();

@Component({ previewImg })
export default class AttachmentModal extends Vue {
  @Prop({ default: null }) data: RepairFileVo;
  @Prop({ default: false }) visible: Boolean;
  imgList: any = [];
  previewVisible = false;
  previewIndex = 0;
  listInfo = [];
  encode = "UTF-8";
  list = [];

  @Emit()
  close() {}

  @Watch("visible", { immediate: true })
  handleShow(val) {
    if (val) {
      this.imgList = [];
    }
  }

  @Watch("data", { immediate: true, deep: true })
  handleImg(val) {
    this.imgList = [];
    this.listInfo = [];
    if (val.fileAddDTOList && val.fileAddDTOList.length) {
      this.list = val.fileAddDTOList;
      this.getListInfo();
      // val.fileAddDTOList.map(async (file, index) => {
      //   this.imgList[index] = await getImg(file)
      //   this.imgList = cloneDeep(this.imgList)
      // })
    }
  }

  openPreview(i) {
    this.previewVisible = true;
    this.previewIndex = i;
  }

  closePreview() {
    this.previewVisible = false;
  }

  changeEncode(val) {
    this.encode = val;
    this.getListInfo();
  }

  getListInfo() {
    this.list.map(async (file, index) => {
      let content;

      if (
        file.contentType != "image/jpg" &&
        file.contentType != "image/jpeg" &&
        file.contentType != "image/png" &&
        file.contentType != "image/svg" &&
        file.contentType != "image/gif" &&
        file.contentType != "text/txt" &&
        file.contentType != "text/json" &&
        file.contentType != "application/pdf" &&
        file.contentType != "application/swf" &&
        file.contentType != "image/octet-stream"
      ) {
        file.contentType = "text/txt";
        content = await getTxt(file, this.encode);
      }

      if (file.contentType.indexOf("image") > -1) {
        content = await getImg(file);
      }

      if (file.contentType.indexOf("pdf") > -1) {
        content = await (await resourceService.statFileUsingGET(file.objectKey))
          .data.link;
      }

      let temp = {
        type: file.contentType.substring(0, file.contentType.indexOf("/")),
        content,
      };
      this.listInfo[index] = temp;
      this.listInfo = cloneDeep(this.listInfo);
    });
  }

  render(createElement: CreateElement): VNode {
    return (
      <div>
        <a-modal
          onCancel={this.close}
          title={this.$t("page_tpm_check_watch_file")}
          visible={this.visible}
          destroyOnClose={true}
          maskClosable={false}
          width={1000}
        >
          <div slot="footer">
            <a-button style="margin-right:8px" onClick={this.close}>
              {this.$t("close")}
            </a-button>
          </div>
          <a-row type="flex">
            <a-col span={5} class="text-right pd-r10">
              <span>{this.$t("page_tpm_repair_fault_image")}:</span>
            </a-col>
            <a-col span={16}>
              <a-row gutter={[24, 16]} type="flex" justify="start">
                {this.listInfo.map((item, index) => (
                  <a-col span={8}>
                    {/* <div class="img-panel">
                      <img src={content} onClick={() => {
                        this.openPreview(index)
                      }} style="cursor: pointer;"/>
                    </div> */}
                    <div class="img-panel">
                      {item && item.type && item.type === "image" ? (
                        <img
                          src={item.content}
                          onClick={() => {
                            this.openPreview(index);
                          }}
                          style="cursor: pointer"
                        />
                      ) : null}
                      <div
                        onclick={() => {
                          this.openPreview(index);
                        }}
                        style="position: absolute;z-index: 9999; width:192px; height: 178px;cursor: pointer"
                      ></div>
                      {item && item.type && item.type === "application" ? (
                        <embed
                          src={item.content}
                          onClick={() => {
                            this.openPreview(index);
                          }}
                          style="cursor: pointer"
                        />
                      ) : null}
                      {item && item.type && item.type === "text" ? (
                        <div
                          onClick={() => {
                            this.openPreview(index);
                          }}
                        >
                          <textarea
                            class="txt-content"
                            v-model={item.content}
                            style="cursor: pointer"
                          />
                        </div>
                      ) : null}
                    </div>
                  </a-col>
                ))}
              </a-row>
            </a-col>
          </a-row>
          <a-row type="flex" class="mg-t16">
            <a-col span={5} class="text-right pd-r10">
              <span>{this.$t("page_extranet_Fault_description")}:</span>
            </a-col>
            <a-col span={16}>
              <div style="min-height: 100px;">{this.data.description}</div>
            </a-col>
          </a-row>
        </a-modal>
        <previewImg
          visible={this.previewVisible}
          imgs={this.listInfo}
          index={this.previewIndex}
          onCancel={this.closePreview}
          onChangeEncode={this.changeEncode}
        />
      </div>
    );
  }
}
